import { httpClient } from "./httpClient";

type Response = {
  userId: string;
};

export async function getUserID(email: string): Promise<string> {
  try {
    const { data } = await httpClient.get<Response>(
      `/api/v1/employees/search`,
      {
        params: {
          email,
        },
      }
    );

    return data.userId;
  } catch (error) {
    if (error.response) {
      throw new Error(error.response.data.errorCode);
    } else {
      throw error;
    }
  }
}
